import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  KoTitle, KoText,
  KoModal, KoButton, KoLoader,
  KoToast,
  KoTable,
  KoTooltips,
  KoPagination,
  KoSearch,
  Checkbox,
  KoDropdown,
  KoBadge,
  KoRating,
  KoTabs,
  KoStaicMembers
} from 'packages';
import KoIcon from '@kwapio/icons';
import { ClientsAPI } from '../customers.service';
import { add, remove } from 'shared/store/breadcrumbSlice';
import styles from './ratings.module.scss';
import { RATINGS_ITEMS_COLUMNS } from '../customersList/constant';
import { getCookie } from 'shared/utils/cookies';
import ManageRatings from './ratingForms';
import { calculateOverallRatings } from 'shared/utils';
import { Emoji } from 'emoji-picker-react';
import { Image } from 'antd';
// import { getCookie } from 'shared/utils/cookies';

function Clients() {
  const [rowList, setDataList] = useState();
  const [copy, setCopy] = useState(false);
  const [issueKeys, setIssueKeys] = useState([]);
  const [ratingKeys, setRatingsKeys] = useState([]);
  const [open, setOpen] = useState(false);
  const [openStars, setOpenStars] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isOpenReviewModal, setOpenReviewModal] = useState(false);
  const [totalCount, setTotalCount] = useState();
  
  const [pagination, setPagination] = useState({
    size: 100,
    offset: 0,
    page: 1,
    limit: 100
  });
  const dispatch = useDispatch();

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page

    };
    const p = Object.assign(pagination, query);
    setPagination(p);
    getallRatings(p);
  };


  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      {
        title: 'Admin Console',
        path: 'admin/settings'
      },
      {
        title: 'customers'
      }
    ]));


    getallRatings(pagination);
  }, []);



  const handleMenuClickIssue = (key, isChecked) => {
    let updatedStatusKeys;
    if (isChecked) {
      updatedStatusKeys = [...issueKeys, key];
    } else {
      updatedStatusKeys = issueKeys.filter((id) => id !== key);
    }
    setIssueKeys(updatedStatusKeys);

    let q = pagination;
    if (key) {
      q['type'] = updatedStatusKeys.toString();
    } else {
      delete q?.['type'];
    }
    getallRatings(q);
  };


  const handleMenuClickRatings = (key, isChecked) => {
    let updatedStatusKeys;
    if (isChecked) {
      updatedStatusKeys = [...issueKeys, key];
    } else {
      updatedStatusKeys = issueKeys.filter((id) => id !== key);
    }
    let q = pagination;
    if (key) {
      q['ratings'] = updatedStatusKeys.toString();
    } else {
      delete q?.['ratings'];
    }
    setRatingsKeys(updatedStatusKeys);

    getallRatings(q);
  };

  const getallRatings = (pagination) => {
    setLoading(true);
    ClientsAPI.getallRatings(pagination).then(
      (data) => {
        setDataList();
        setTotalCount(data['totalCount']);
        setDataList(data['ratings']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFinishDelete = () => {
    setLoading(true);
    ClientsAPI.deleteByIdRating(currentRecord?.formId).then(
      (data) => {
        getallRatings();
        KoToast.success('Delete successfully');
        setDeleteModal(false);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onCellClick = (row) => {
    setCurrentRecord(row);
    setOpenReviewModal(true);
  };

  const onSearchText = (text) => {
    let q = pagination;
    q['search'] = text;
    getallRatings(q);
  };

  // const onChangeType = (key) => {
  //   let q = pagination;
  //   if (key) {
  //     q['type'] = key.toString();
  //   } else {
  //     delete q['type'];
  //   }
  //   getallRatings(q);
  // };

  const onCopyTicket = (row) => {
    navigator.clipboard.writeText(`${window.location.origin}/open/ticket/${getCookie("accountId")}/${row?.workspaceId}/${row?.ticketId}`);
    setCopy(true);
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 80,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        <KoTooltips title={'Open'}>
          <KoButton onClick={() => onCellClick(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'OpenOutlined'} />} />
        </KoTooltips>
        <KoTooltips title={copy ? 'Copied' : 'Copy'}>
          <KoButton onClick={() => onCopyTicket(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'ShareOutlined'} />} />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton onClick={() =>   {setDeleteModal(true); setCurrentRecord(row);}} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>
      </div>;
    }
  }];

    
  const issueTypesList = [
    { value: 1,
      label: 'Retail / E-Commerce'},
    {value: 2,
      label: 'SaaS / Software'},
    { value: 3,
      label: 'Healthcare / Hospital'
    },
    {
      value: 4,
      label: 'Restaurant'
    },
    {
      value: 5,
      label: 'Resorts / Hotel'
    },
    {
      value: 6,
      label: 'Education / Training'
    },
    {
      value: 7,
      label: 'Service / Maintenance'
    }
  ].map((issue) => ({
    label: (
      <div className={`${styles.filterList} ${issueKeys.includes(issue.value) ? styles.selected : ""}`}>
        <Checkbox
          checked={issueKeys.includes(issue.value)}
          onChange={(e) => handleMenuClickIssue(issue.value, e.target.checked)}>
          <div className={styles.userDpWithName}>
            <KoText text={issue.label} />
          </div>
        </Checkbox>
      </div>
    ),
    key: issue?.key,
    value: issue?.key
  }));

  const starTypesList = [
    {
      value: 5,
      label: <KoRating value={5}/>
    },
    {
      value: 4,
      label: <KoRating value={4}/>
    },
    { value: 3,
      label: <KoRating value={3}/>
    },
    { value: 2,
      label: <KoRating value={2}/>
    },
    { value: 1,
      label: <KoRating value={1}/>
    }
  ].map((issue) => ({
    label: (
      <div className={`${styles.filterList} ${ratingKeys.includes(issue.value) ? styles.selected : ""}`}>
        <Checkbox
          checked={ratingKeys.includes(issue.value)}
          onChange={(e) => handleMenuClickRatings(issue.value, e.target.checked)}>
          <div className={styles.userDpWithName}>
            <KoText text={issue.label} />
          </div>
        </Checkbox>
      </div>
    ),
    key: issue?.key,
    value: issue?.key
  }));

  const handleOpenChange = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpen(nextOpen);
    }
  };

  const handleOpenChangeStar = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpenStars(nextOpen);
    }
  };


  const retunLable= (value) => {
    let label = '';
    let color = '';
    if (value >= 4.5) {
      label = 'Great';
      color = '#3b82f6'; // blue
    } else if (value >= 3.5) {
      label = 'Good';
      color = '#16a34a'; // green
    } else if (value >= 2.5) {
      label = 'So-so';
      color = '#a855f7'; // purple
    } else if (value >= 1.5) {
      label = 'Bad';
      color = '#f59e0b'; // orange
    } else {
      label = 'Worst';
      color = '#dc2626'; // red
    }

    return {
      label,
      color
    };
  };

  return <div className={`${styles.wrapper} profileSection`}>
    {isLoading && <KoLoader />}
   
    <KoTabs options={[
      {
        label: "Ratings",
        key: "ratings",
        children:  <div className={styles.customerList}>
          <div className={styles.tableData}>
            <div className={'tableCard'}>
              <div className={styles.header}>
                <KoTitle text="Ratings" level={4} className={styles.title} />
                <div className={styles.search}>
                  <KoSearch placeholder="Search by Email, Rating Type" onChange={ (e) => { onSearchText(e);}} />
                  <KoDropdown
                    onOpenChange={handleOpenChangeStar}
                    open={openStars}
                    placement="bottomRight"
                    menu={{items: starTypesList }}>
                    <div>
                      <KoBadge  count={ratingKeys?.length}>
                        <KoTooltips title="Filter by ratings">
                          <KoButton
                            iconBtn={true}
                            icon={<KoIcon name="StarOutlined" />}
                          />
                        </KoTooltips>
                      </KoBadge>
                    </div>
                  </KoDropdown>

                  <KoDropdown
                    onOpenChange={handleOpenChange}
                    open={open}
                    placement="bottomRight"
                    menu={{items: issueTypesList }}>
                    <div>
                      <KoBadge  count={issueKeys?.length}>
                        <KoTooltips title="Filter Rating Types">
                          <KoButton
                            iconBtn={true}
                            icon={<KoIcon name="FileOutlined" />}
                          />
                        </KoTooltips>
                      </KoBadge>
                    </div>
                  </KoDropdown>
                </div>
              </div>
        
              <KoTable rowKey='formId'
                onCellClick={onCellClick}
                refreshData={getallRatings}
                data={{ columns: RATINGS_ITEMS_COLUMNS, rows: rowList }}
                extraColumnsRight={columnsRight} />
              <KoPagination current={parseInt(pagination.page) || 1}
                total={totalCount}
                showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
                }
                pageSize={pagination.limit}
                defaultCurrent={pagination.page}
                onChange={onPagination}
                showQuickJumper={false}
                simple={false}
                responsive={false} />
            </div>
          </div>
        </div>
      },
      {
        label: "Rating Forms",
        key: "reviews",
        children: <ManageRatings />
      }
    ]} />
    <KoModal
      title={`Delete Customer ${currentRecord?.email?.toUpperCase()}`}
      centered
      open={isOpenDelete}
      afterClose={() => {setCurrentRecord();}}
      handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
      onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
      width={580}
      // maskClosable={false}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
        <KoButton key='reset' loading={isLoading}color="danger" variant="solid"  type='primary' label='Delete' onClick={() => handleFinishDelete()} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={styles.delWrapper}>
        <KoTitle level={5} text={`Are you sure you want to delete this Customer Rating?`} />
        <KoText text={`${currentRecord?.comments}`} />
      </div>
    </KoModal>
    <KoModal
      title={`Review & Comments`}
      centered
      open={isOpenReviewModal}
      afterClose={() => {setCurrentRecord();}}
      handleOk={() => { setCurrentRecord(); setOpenReviewModal(false); }}
      onClose={() => { setCurrentRecord(); setOpenReviewModal(false); }}
      width={'70vw'}
      footer={[
        <KoButton key='cancel' label='Close' onClick={() => setOpenReviewModal(false)} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={styles.reviewWrapper}>
        <div className={styles.ratingsDeatils}>
          <KoTitle text='Overall Rating' level={3} />
          <div className={styles.overall}>
            <KoTitle text={`${calculateOverallRatings(currentRecord?.ratings)}`} level={1} />
            <KoRating disabled value={calculateOverallRatings(currentRecord?.ratings)} />
            <div className={`${styles.ratingHeader} ${styles.averageRating}`} >
              <div className={styles.ratingText}>
                <span className={styles.average}>Average :</span>
                <span className={styles.label} style={{ color: retunLable(calculateOverallRatings(currentRecord?.ratings)).color }}>
                  {' '}{retunLable(calculateOverallRatings(currentRecord?.ratings)).label}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.commentsSection}>
            <div className={styles.members}>
              <KoStaicMembers data={{firstName: currentRecord?.email, date: currentRecord?.createdAt}} />
            </div>
            <div className={styles.comments}>
              <KoText className={styles.commentText} text={`${currentRecord?.comments}`} />
            </div>
            <div className={styles.commentLike}>
              <KoButton type='text' text={'10'} icon={<KoIcon name="ThumbUpOutlined" />} />
              <KoButton text={'10'} type='text' icon={<KoIcon name="ThumbDownOutlined" />} />
              {currentRecord?.reactions?.length > 0 && <div className={`${styles.reactionsContainer}`}>
                {currentRecord?.reactions?.map((reaction, index) => (
                  <div className={styles.reaction} key={index}>
                    <span className={styles.reactionIcon} >
                      <Emoji
                        size={17}
                        unified={reaction?.emoji}
                      />
                    </span>
                    {index === currentRecord?.reactions?.length-1 && currentRecord?.reactions?.length > 1 && <KoText text={currentRecord?.reactions?.length} className={styles.reactionCount} />}
                  </div>
                ))}
              </div>}
            </div>
          </div>
        </div>
        <div className={styles.ratingsListDeatils}>
          <KoTitle text='Evaluations' level={3} />
          <div className={styles.ratingsList}>
            {
              currentRecord?.ratings?.map((item, index) => (
                <div key={index} className={styles.ratingContainer}>
                  {Object.entries(item).map(([key, value]) => {
                    let label = '';
                    let color = '';
                    if (value >= 4.5) {
                      label = 'Great';
                      color = '#3b82f6'; // blue
                    } else if (value >= 3.5) {
                      label = 'Good';
                      color = '#16a34a'; // green
                    } else if (value >= 2.5) {
                      label = 'So-so';
                      color = '#a855f7'; // purple
                    } else if (value >= 1.5) {
                      label = 'Bad';
                      color = '#f59e0b'; // orange
                    } else {
                      label = 'Worst';
                      color = '#dc2626'; // red
                    }

                    return (
                      <div key={key} className={styles.ratingItem}>
                        <div className={styles.ratingHeader}>
                          <KoTitle
                            level={5}
                            className={styles.ratingTitle}
                            text={key.replace(/([A-Z])/g, ' $1')}
                          />
                          <div className={styles.ratingText}>
                            <span className={styles.average}>Average :</span>
                            <span className={styles.label} style={{ color }}>
                              {' '}{label}
                            </span>
                          </div>
                        </div>
                        <KoRating disabled value={value} />
                      </div>
                    );
                  })}
                </div>
              ))
            }

          </div>
          <div className={styles.attachments}>
            <KoTitle text='Attachments' level={3} />
            <div className={styles.attachmentsContainer}>
              <Image
                width={100}
                src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
              />
            </div>
          </div>
        </div>
      </div>
    </KoModal>
  </div>;
}

export default Clients;
